import { Modal } from '@ts/components/Modal';
import { Share } from '@ts/components/Share';
import { CopyButton } from '@ts/components/CopyButton';

export const init = () => {
    setHTMXListeners();
    setInteractiveElements();
    setRemoveParticipantTrigger();
}

const setHTMXListeners = () => {
    document.body.addEventListener('htmx:afterSwap', setInteractiveElements);
    document.body.addEventListener('htmx:historyRestore', setInteractiveElements);
}

const setInteractiveElements = () => {
    setCloseModalTrigger();
    setInlineShareParticipantMessage();
}

const setRemoveParticipantTrigger = () => {
    const contactsTbody = document.querySelector('#contacts-tbody');
    if (!contactsTbody) return;

    contactsTbody.addEventListener('click', (e) => {
        const removeButton = e.target.closest('.remove-participant');
        if (!removeButton) return;

        e.preventDefault();
        confirmRemoveParticipant(removeButton);
    });
}

const confirmRemoveParticipant = (removeButton) => {
    const { participantName, removeParticipantUrl } = removeButton.dataset;

    Modal.createConfirmModal({
        title: 'Remove Team Member',
        message: `Are you sure you want to remove ${participantName}? This can't be undone, but you can always add them again.`,
        confirmText: 'Remove',
        cancelText: 'Cancel',
        onConfirm: async () => removeParticipant(removeButton, removeParticipantUrl)
    });
}

const removeParticipant = async (removeButton, removeParticipantUrl) => {
    try {
        const response = await fetch(removeParticipantUrl, { method: 'DELETE' });

        if (response.ok) {
            const contactsTbody = document.querySelector('#contacts-tbody');
            const participantRow = removeButton.closest('tr');

            if (!contactsTbody || !participantRow) return;

            if (contactsTbody.children.length > 1) {
                participantRow.remove();
                return;
            }

            displayNoParticipantsRow(participantRow, contactsTbody);

            return;
        }

        Modal.createAlertModal({
            title: 'Remove Failed',
            message: 'There was a problem removing this Team Member, please try again.'
        });
    } catch (error) {
        console.error('Error removing participant:', error);
    }
}

const displayNoParticipantsRow = (participantRow, contactsTbody) => {
    const contactsTable = contactsTbody.closest('table');
    if (!contactsTable) return;

    contactsTable.classList.add('no-results');
    participantRow.classList.add('is-empty');

    participantRow.querySelectorAll('.cell-value').forEach(cellValue => cellValue.textContent = '');
    participantRow.querySelector('.contact-info')?.remove();
    participantRow.querySelector('.remove-participant')?.remove();

    const contactsStatus = participantRow.querySelector('.contacts-status');
    if (contactsStatus) {
        const emptyStatusValue = document.createElement('span');
        emptyStatusValue.classList.add('cell-value');
        contactsStatus.replaceChildren(emptyStatusValue);
    }

    const noResultsMessage = contactsTable.closest('.table-container')?.querySelector('.no-results-message');
    if (noResultsMessage) noResultsMessage.hidden = false;
}

const setInlineShareParticipantMessage = () => {
    const shareButton = document.querySelector('#share-participant-message-btn');
    if (!shareButton) return;
    
    const webshare = Share.create(shareButton, {
        text: document.querySelector('.funderworks-share-invite-message')?.textContent,
        onSuccess: (event) => handleShareSuccess(shareButton),
        onFail: (event) => handleShareFail()
    });
}

const setCloseModalTrigger = () => {
    const closeModalButton = document.querySelector('.close-participant-share-modal');
    if (!closeModalButton) return;
    closeModalButton.addEventListener('click', (e) => {
        e.preventDefault();
        Modal.closeAllModals();
    });
}

const handleShareFail = () => {
    const postShareContent = document.querySelector('.post-share-success');
    if (!postShareContent) return;
    postShareContent.dataset.shareStatus = 'failed';
}

const handleShareSuccess = async (btn) => {
    const confirmShareUrl = btn.dataset.confirmShare;
    if (!confirmShareUrl) return;

    const response = await fetch(confirmShareUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: '{}'
    });
    
    if (!response.ok) {
        throw new Error(`Confirm share failed: ${response.status}`);
        return;
    }
}